import { ApolloError } from '@apollo/client';
import { ExpectedSendSize } from 'modules/campaigns/lib/hooks';
import { GraphQLCampaign } from 'modules/campaigns/lib/types';
import { CampaignLabel } from 'modules/domains/campaign';
import { createContext, useContext } from 'react';
import noop from 'utils/noop';

export type CampaignSendSizeState = {
  isLoading: boolean;
  isFetching: boolean;
  sendSize: ExpectedSendSize;
  refetch: () => void;
  hasError: boolean;
};

export interface CampaignContextState {
  errorMessage: string | ApolloError;
  hasError: boolean;
  isLoading: boolean;
  campaign: GraphQLCampaign;
  refetch: () => void;
  expectedSendSizeData: CampaignSendSizeState;
  estimatedSendSizeData: CampaignSendSizeState;
  campaignProjectLabels: CampaignLabel[];
  refetchCampaignProjectLabels: () => void;
  nbaEnabledCampaignIds: number[];
}

const DEFAULT_CAMPAIGN_SEND_SIZE_DATA: CampaignSendSizeState = {
  isLoading: false,
  isFetching: false,
  sendSize: undefined,
  refetch: noop,
  hasError: false,
};

export const DEFAULT_CAMPAIGN_CONTEXT_STATE: CampaignContextState = {
  errorMessage: '',
  hasError: false,
  isLoading: true,
  campaign: {} as GraphQLCampaign,
  expectedSendSizeData: DEFAULT_CAMPAIGN_SEND_SIZE_DATA,
  estimatedSendSizeData: DEFAULT_CAMPAIGN_SEND_SIZE_DATA,
  refetch: noop,
  campaignProjectLabels: [],
  refetchCampaignProjectLabels: noop,
  nbaEnabledCampaignIds: [],
};

export const CampaignContext = createContext<CampaignContextState>(DEFAULT_CAMPAIGN_CONTEXT_STATE);
export const useCampaignContext = () => useContext(CampaignContext);
